import { useQuery } from 'react-query'
import { removeDefaultParams } from 'src/common/utils'
import { IFilter } from 'src/components/filter/types/filter.types'
import { QUERY_KEYS } from 'src/constants'
import { ratingSettingsService } from 'src/services/rating-settings.service'

export const initialRatingSettings = {
  query: '',
}

export const useRatingSettings = (filter?: IFilter) => {
  return useQuery(
    [QUERY_KEYS.RATING_SETTINGS, filter || initialRatingSettings],
    () =>
      ratingSettingsService.getRatingSettings(removeDefaultParams(filter, initialRatingSettings)),
    {
      keepPreviousData: true,
    },
  )
}
